<form [formGroup]="policyDataForm" *ngIf="accidentDetail">
  <div class="grid-col-3">
    <!-- Codigo Asegurado -->
    <div class="input-container">
      <span class="label">Código Asegurado</span>
      <div class="input">
        <input
          formControlName="codigoAsegurado"
          type="text"
          placeholder="Código Asegurado"
        />
      </div>
    </div>
    <!-- Nombre Asegurado -->
    <div class="input-container">
      <span class="label">Nombre Asegurado</span>
      <div class="input">
        <input
          formControlName="nombreAsegurado"
          type="text"
          placeholder="Nombre Asegurado"
        />
      </div>
    </div>
    <!-- Deducible -->
    <div class="input-container">
      <span class="label">Deducible</span>
      <div class="input">
        <input
          formControlName="autoDeducible"
          type="text"
          placeholder="Deducible"
        />
      </div>
    </div>
    <!-- Número de póliza -->
    <div class="input-container">
      <span class="label">Número de póliza</span>
      <div class="input">
        <input
          formControlName="numeroPoliza"
          type="text"
          placeholder="Número de póliza"
        />
      </div>
    </div>
    <!-- Número de carpeta -->
    <div class="input-container">
      <span class="label">Número de carpeta</span>
      <div class="input">
        <input
          formControlName="numeroCarpeta"
          type="text"
          placeholder="Número de carpeta"
        />
      </div>
    </div>
    <!-- Id contract management -->
    <div class="input-container">
      <span class="label">Id contract management</span>
      <div class="input">
        <input
          formControlName="idContractManagement"
          type="text"
          placeholder="Id contract management"
        />
      </div>
    </div>
    <!-- Fecha inicio vigencia póliza -->
    <div class="input-container">
      <span class="label">Fecha inicio vigencia póliza</span>
      <div class="input">
        <input
          formControlName="fechaInicioVigenciaPoliza"
          type="text"
          placeholder="Fecha inicio vigencia póliza"
        />
        <i class="fas fa-calendar-alt"></i>
      </div>
    </div>
    <!-- Fecha fin vigencia póliza -->
    <div class="input-container">
      <span class="label">Fecha fin vigencia póliza</span>
      <div class="input">
        <input
          formControlName="fechaFinVigenciaPoliza"
          type="text"
          placeholder="Fecha fin vigencia póliza"
        />
        <i class="fas fa-calendar-alt"></i>
      </div>
    </div>
    <!-- Numero omega -->
    <div class="input-container">
      <span class="label">Nro. omega</span>
      <div class="input">
        <input
          formControlName="numeroOmega"
          type="text"
          placeholder="Nro. Omega"
        />
      </div>
    </div>
    <!-- Nombre de Paquete -->
    <div class="input-container">
      <span class="label">Paquete</span>
      <div class="input">
        <input
          formControlName="nombrePaquete"
          type="text"
          placeholder="Código-Nombre de paquete"
        />
      </div>
    </div>
    <!-- Nombre de cobertura -->
    <div class="input-container">
      <span class="label">Nombre de cobertura</span>
      <div class="input">
        <input
          formControlName="nombreCobertura"
          type="text"
          placeholder="Nombre de cobertura"
        />
      </div>
    </div>
    <!-- Slip de reaseguro -->
    <div class="input-container">
      <span class="label">Slip de reaseguro</span>
      <div class="input">
        <input
          formControlName="slipReaseguro"
          type="text"
          placeholder="Slip de reaseguro"
        />
      </div>
    </div>
    <!-- Nombre de corredor -->
    <div class="input-container">
      <span class="label">Nombre de corredor</span>
      <div class="input">
        <input
          formControlName="nombreCorredor"
          type="text"
          placeholder="Nombre de corredor"
        />
      </div>
    </div>
    <!-- Tipo de endoso -->
    <div class="input-container">
      <span class="label">Tipo de endoso</span>
      <div class="input">
        <input
          formControlName="tipoEndoso"
          type="text"
          placeholder="Tipo de endoso"
        />
      </div>
    </div>
    <!-- Tipo de póliza -->
    <div class="input-container">
      <span class="label">Tipo de póliza</span>
      <div class="input">
        <input
          formControlName="tipoPoliza"
          type="text"
          placeholder="Tipo de póliza"
        />
      </div>
    </div>
    <!-- Coaseguro -->
    <div class="input-container">
      <span class="label">Coaseguro</span>
      <div class="input">
        <input
          formControlName="coaseguro"
          type="text"
          placeholder="Coaseguro"
        />
      </div>
    </div>
    <!-- Auto cortesía -->
    <!-- <div class="input-container">
         <span class="label">Auto cortesía</span>
         <div class="input">
            <input formControlName="autoCortesia"
               type="text"
               placeholder="Auto cortesía" />
         </div>
      </div> -->
    <!-- Cobertura granizo -->
    <!-- <div class="input-container">
         <span class="label">Cobertura granizo</span>
         <div class="input">
            <input formControlName="coberturaGranizo"
               type="text"
               placeholder="Cobertura granizo" />
         </div>
      </div>-->
    <!-- Espirometria -->
    <div
      class="input-container input-comentarios-adicionales d-flex align-items-center justify-content-around"
    >
      <div class="input-container">
        <span class="label">Espirometría </span>

        <label class="custom-radio-button-container"
          >Si
          <input
            formControlName="espirometria"
            [value]="true"
            type="radio"
            name="espirometria"
          />
          <span class="checkmark"></span>
        </label>

        <label class="custom-radio-button-container"
          >No
          <input
            formControlName="espirometria"
            [value]="false"
            type="radio"
            name="espirometria"
          />
          <span class="checkmark"></span>
        </label>
      </div>
      <!-- Auto de Cortesia -->
      <div class="input-container">
        <span class="label">Auto de cortesía</span>

        <label class="custom-radio-button-container"
          >Si
          <input
            formControlName="autoCortesia"
            [value]="true"
            type="radio"
            name="autoCortesia"
          />
          <span class="checkmark"></span>
        </label>

        <label class="custom-radio-button-container"
          >No
          <input
            formControlName="autoCortesia"
            [value]="false"
            type="radio"
            name="autoCortesia"
          />
          <span class="checkmark"></span>
        </label>
      </div>
      <!-- Cobertura Granizo -->
      <div class="input-container">
        <span class="label">Auto de cortesía</span>

        <label class="custom-radio-button-container"
          >Si
          <input
            formControlName="coberturaGranizo"
            [value]="true"
            type="radio"
            name="coberturaGranizo"
          />
          <span class="checkmark"></span>
        </label>

        <label class="custom-radio-button-container"
          >No
          <input
            formControlName="coberturaGranizo"
            [value]="false"
            type="radio"
            name="coberturaGranizo"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</form>
